<template>
  <div>
    <div class="container" v-show="devices.length">
      <web-cam
        ref="webcam"
        :device-id="deviceId"
        width="100%"
        :autoplay="autoplay"
        @error="onError"
        @cameras="onCameras"
        @camera-change="onCameraChange"
      />

      <v-select
        label="Устройство"
        id="cameras"
        :key="deviceId"
        item-text="label"
        item-value="deviceId"
        :items="devices"
        v-model="camera"
      />

      <v-btn
        color="success"
        flat
        @click="onCapture"
      >Сфотографировать</v-btn>
      <v-btn color="danger" flat @click="onClose">Закрыть</v-btn>
    </div>
    <div v-show="!devices.length && !error">Поиск доступных камер...</div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { WebCam } from 'vue-web-cam';

export default {
  name: 'WebCamModal',
  components: { WebCam },
  props: {
    openCamera: Boolean,
  },
  data() {
    return {
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      error: '',
      autoplay: true,
    };
  },
  computed: {
    device() {
      return this.devices.find(n => n.deviceId === this.deviceId);
    },
  },
  beforeMount() {
    if (this.devices.length === 0) {
      // this.error = 'Нет доступных камер';
    }
  },
  mounted() {
    this.onStop();
  },
  watch: {
    camera(id) {
      this.deviceId = id;
    },
    devices() {
      // Once we have a list select the first one
      const first = this.devices[0];
      if (this.devices.length === 0) {
        this.error = 'Нет доступных камер';
      } else {
        this.deviceId = first.deviceId;
        this.camera = first.deviceId;
        this.error = '';
      }
    },
    error(error) {
      this.$emit('error', error);
    },
    openCamera(openCamera) {
      this.autoplay = openCamera;
      if (openCamera) {
        this.onStart();
      } else {
        this.onStop();
      }
    },
  },
  methods: {
    onCapture() {
      fetch(this.$refs?.webcam?.capture())
        .then(res => res.blob())
        .then((blob) => {
          const file = new File([blob], 'screen.jpeg', {
            type: 'image/jpeg',
          });
          this.$emit('onCapture', file);
        });
    },
    onStop() {
      this.$refs?.webcam?.stop();
    },
    onStart() {
      this.$refs?.webcam?.start();
    },
    onError(error) {
      error && this.$set(this.$data, 'error', error);
    },
    onCameras(cameras) {
      cameras && this.$set(this.$data, 'devices', cameras);
    },
    onCameraChange(deviceId) {
      if (deviceId) {
        this.$set(this.$data, 'deviceId', deviceId);
        this.$set(this.$data, 'camera', deviceId);
      }
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>
